import {DETAILS_DASHBOARD_REQUEST} from '../constants/reducer.const';

export const dashboardDetailsAction = ()=>({type: DETAILS_DASHBOARD_REQUEST, payload: {}});
